(function () {
  'use strict';

  function initFilterDrawer() {
    var toggleBtn = document.querySelector('[data-cof-filter-toggle]');
    var closeBtn = document.querySelector('[data-cof-filter-close]');
    var filters = document.querySelector('[data-cof-filters]');
    var backdrop = document.querySelector('[data-cof-filter-backdrop]');

    if (!toggleBtn || !filters || !backdrop) return;

    function openDrawer() {
      filters.classList.add('is-open');
      backdrop.classList.add('is-open');
      backdrop.hidden = false;
      toggleBtn.setAttribute('aria-expanded', 'true');
    }

    function closeDrawer() {
      filters.classList.remove('is-open');
      backdrop.classList.remove('is-open');
      backdrop.hidden = true;
      toggleBtn.setAttribute('aria-expanded', 'false');
    }

    toggleBtn.addEventListener('click', openDrawer);
    if (closeBtn) closeBtn.addEventListener('click', closeDrawer);
    backdrop.addEventListener('click', closeDrawer);
  }

  function initAccordions() {
    var toggles = document.querySelectorAll('[data-cof-accordion-toggle]');
    toggles.forEach(function (toggle) {
      var body = toggle.parentElement.querySelector('[data-cof-accordion-body]');
      if (!body) return;

      toggle.addEventListener('click', function () {
        var expanded = toggle.getAttribute('aria-expanded') === 'true';
        toggle.setAttribute('aria-expanded', String(!expanded));
        body.hidden = expanded;
      });
    });
  }

  function initAutoSubmit() {
    var form = document.querySelector('[data-cof-filter-form]');
    if (!form) return;

    var checkboxes = form.querySelectorAll('[data-cof-auto-submit]');
    checkboxes.forEach(function (checkbox) {
      checkbox.addEventListener('change', function () {
        form.submit();
      });
    });
  }

  function initSort() {
    var select = document.querySelector('[data-cof-auto-submit-select]');
    if (!select) return;

    select.addEventListener('change', function () {
      select.closest('form').submit();
    });
  }

  function initViewToggle() {
    var buttons = document.querySelectorAll('[data-cof-view]');
    var grid = document.querySelector('[data-cof-grid]');
    if (!buttons.length || !grid) return;

    var stored = window.localStorage ? localStorage.getItem('cof-view-preference') : null;
    if (stored === 'list') {
      grid.classList.add('cof-grid--list');
      buttons.forEach(function (btn) {
        btn.classList.toggle('is-active', btn.dataset.cofView === 'list');
      });
    }

    buttons.forEach(function (button) {
      button.addEventListener('click', function () {
        var view = button.dataset.cofView;
        grid.classList.toggle('cof-grid--list', view === 'list');
        buttons.forEach(function (btn) {
          btn.classList.toggle('is-active', btn === button);
        });
        if (window.localStorage) {
          localStorage.setItem('cof-view-preference', view);
        }
      });
    });
  }

  function init() {
    initFilterDrawer();
    initAccordions();
    initAutoSubmit();
    initSort();
    initViewToggle();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
